// Shared type-ahead matching for customer / product pickers.
//
// The old picker did a literal substring match and showed only the first 10
// hits, which hid real matches two ways: typing "TPF" matched 14 customers
// but listed 10, and typing "TPF(" skipped "TPF (AVADI)" because of the
// space before the bracket. Matching here ignores punctuation and spacing,
// requires every typed word to appear, and returns far more rows (with the
// real total so the picker can say when it is truncating).

const words = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

export function matchItems(items, query, getLabel, limit = 50) {
  const q = words(query);
  if (!q) {
    return { list: items.slice(0, limit), total: items.length };
  }
  const tokens = q.split(" ");
  const qCompact = tokens.join("");
  const prefix = [];
  const rest = [];
  for (const item of items) {
    const label = getLabel(item) || "";
    const w = words(label);
    const c = w.replace(/ /g, "");
    // every word typed appears (any order), or the letters run together
    // across a space/bracket in the name ("tpfcbe" -> "TPF (CBE)")
    if (!tokens.every((t) => w.includes(t)) && !c.includes(qCompact)) continue;
    (c.startsWith(qCompact) ? prefix : rest).push(item);
  }
  const all = prefix.concat(rest);
  return { list: all.slice(0, limit), total: all.length };
}
